// Pemformatan yang dikongsi Worker & frontend: wang (sen → RM), peratus, tarikh ikut bahasa,
// dan teks lejar kewangan yang dijana daripada jenis + metadata entri (bukan teks tersimpan).

export function money(minor, { exact = false } = {}) {
  const n = Number(minor) || 0;
  const abs = Math.abs(n);
  const whole = Math.floor(abs / 100).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  const cents = String(abs % 100).padStart(2, '0');
  return `${n < 0 ? '-' : ''}RM${whole}${exact || cents !== '00' ? '.' + cents : ''}`;
}

export function pct(bps) {
  const v = (Number(bps) || 0) / 100;
  return `${Number.isInteger(v) ? v : v.toFixed(2).replace(/0$/, '')}%`;
}

export function monthName(t, m, short = false) {
  return t(`date.${short ? 'months_short' : 'months'}.${m}`);
}

export function formatDate(t, iso, { short = false } = {}) {
  if (!iso) return '';
  const [y, m, d] = iso.split('-').map(Number);
  return t(short ? 'date.format_short' : 'date.format', { d, month: monthName(t, m, true), y });
}

export function formatTimestamp(t, ms, withTime = true) {
  if (!ms) return '';
  // Waktu Malaysia (UTC+8) secara tetap supaya pelayan dan pelayar memaparkan masa yang sama.
  const dt = new Date(ms + 8 * 3_600_000);
  const base = t('date.format', { d: dt.getUTCDate(), month: monthName(t, dt.getUTCMonth() + 1, true), y: dt.getUTCFullYear() });
  return withTime ? t('date.format_time', { date: base, time: `${String(dt.getUTCHours()).padStart(2, '0')}:${String(dt.getUTCMinutes()).padStart(2, '0')}` }) : base;
}

export function monthLabel(t, ym) {
  const [y, m] = ym.split('-').map(Number);
  return `${monthName(t, m, true)} ${String(y).slice(2)}`;
}

// Teks satu entri lejar dalam bahasa t. Teks `description` tersimpan (bahasa utama) hanya untuk audit.
export function ledgerText(t, e) {
  const m = e.meta || {};
  const booking = e.booking_id || '';
  const amount = e.amount ?? e.amount_minor;
  switch (e.type) {
    case 'BOOKING_PAYMENT':
      return t('ledger.BOOKING_PAYMENT', { booking, gateway: m.gateway ? t(`gateway.${m.gateway}`) : '', test: m.livemode === false ? t('ledger.test_suffix') : '' });
    case 'PLATFORM_FEE':
      return t('ledger.PLATFORM_FEE', { booking, rate: pct(m.rate_bps) });
    case 'SERVICE_FEE':
    case 'TAX_COLLECTED':
    case 'PROMO_SUBSIDY':
    case 'PENDING_TO_AVAILABLE':
      return t(`ledger.${e.type}`, { booking });
    case 'HOST_PENDING_EARNING':
      return t('ledger.HOST_PENDING_EARNING', { booking, gross: money(m.gross_minor), fee: money(m.fee_minor), net: money(amount) });
    case 'REFUND':
      return e.wallet_id === 'PLATFORM' || e.wallet_owner_type === 'PLATFORM'
        ? t('ledger.REFUND_platform', { ref: e.reference, booking })
        : t('ledger.REFUND_host', { ref: e.reference, booking, bucket: t(m.bucket === 'available_minor' ? 'wallet.available' : 'wallet.pending') });
    case 'REFUND_REVERSAL':
      return t('ledger.REFUND_REVERSAL', { ref: e.reference });
    case 'WITHDRAWAL_REQUEST':
      return t('ledger.WITHDRAWAL_REQUEST', { ref: m.withdrawal_id || e.reference });
    case 'WITHDRAWAL':
      return e.wallet_id === 'PLATFORM' || e.wallet_owner_type === 'PLATFORM'
        ? t('ledger.WITHDRAWAL_platform', { ref: m.withdrawal_id || '', host: m.host_id || '' })
        : t('ledger.WITHDRAWAL', { ref: m.withdrawal_id || '', bank: m.bank || '', account: m.account || '' });
    case 'WITHDRAWAL_REVERSAL':
      return t('ledger.WITHDRAWAL_REVERSAL', { ref: m.withdrawal_id || e.reference, status: m.status ? t(`status.${m.status}`) : '' });
    case 'ADJUSTMENT':
    case 'BONUS':
    case 'PENALTY':
      return t('ledger.ADJUSTMENT', { type: t(`tx.${e.type}`), reason: m.reason ?? '' });
    default:
      return t(`tx.${e.type}`);
  }
}

export function policyDescription(t, policy) {
  const rules = [...(policy?.rules || [])].sort((a, b) => b.min_hours_before - a.min_hours_before).filter((r) => r.refund_bps > 0);
  if (!rules.length) return t('policy.no_refund');
  return rules.map((r) => t(r.refund_bps === 10000 ? 'policy.rule_full' : 'policy.rule_partial', { pct: pct(r.refund_bps), time: hoursText(t, r.min_hours_before) })).join(' ');
}

export function hoursText(t, h) {
  if (h >= 48 && h % 24 === 0) return t('time.days', { n: h / 24 });
  return t('time.hours', { n: h });
}
